/* React */
import React, { useState } from "react";

/* Ionic */
import {
  IonAccordionGroup,
  IonAccordion,
  IonItem,
} from "@ionic/react";

import { documentText, folderOpen } from "ionicons/icons";

/* React Redux */
import { useDispatch } from "react-redux";
import { AppDispatch } from "src/redux/store";

/* Thunks */
import { importTestData } from "src/redux/thunks/test-data/testDataThunk";

/* Components */
import ToolbarContainer from "src/components/admin-dashboard/data-handler/toolbar-container/ToolbarContainer";
import ItemSlidingOptions from "src/components/admin-dashboard/data-handler/item-sliding-options/ItemSlidingOptions";
import ItemOption from "src/components/admin-dashboard/data-handler/item-option/ItemOption";

/* Stylesheet */
import styles from "./ImportDataHandler.module.scss";

/* Interfaces */
import { TestDataProps } from "src/shared/interfaces/common/TestData";

interface ImportHandlerProps {
  data?: Record<string, TestDataProps[]>;
  importedData: TestDataProps[];
}

const ImportDataHandler: React.FC<ImportHandlerProps> = ({
  data,
  importedData,
}) => {
  const dispatch = useDispatch<AppDispatch>();

  const [activeValue, setActiveValue] = useState<
    string | null
  >(null);

  return (
    <div className={styles.import_data_handler}>
      <ToolbarContainer
        icon={folderOpen}
        label={"Data import"}
      />
      <IonAccordionGroup
        onIonChange={(e) =>
          setActiveValue((e.detail.value as string) || null)
        }
      >
        {Object.entries(data || {}).map(
          ([key, items], index) => {
            const activeItem = activeValue === key;
            const disabled = importedData.some(
              (existing) => existing?.condition === key
            );
            return (
              <IonAccordion
                key={index}
                className={styles.accordion}
                value={key}
              >
                <IonItem
                  style={{
                    background: activeItem
                      ? "#f3f5f7"
                      : undefined,
                  }}
                  className={`${styles.header} item_primary`}
                  slot="header"
                  lines="none"
                  disabled={disabled}
                >
                  <div className={styles.key}>{key}</div>
                </IonItem>
                {items.map((item, index) => {
                  return (
                    <div
                      key={index}
                      style={{
                        background:
                          index % 2 === 0
                            ? "#ffffff"
                            : "var(--ion-gradient-light)",
                      }}
                      className={styles.content_container}
                      slot="content"
                    >
                      <ItemSlidingOptions
                        item={item}
                        disabled={disabled}
                        option={
                          <ItemOption
                            label={"Import"}
                            icon={documentText}
                            onClick={() => {
                              dispatch(
                                importTestData(item)
                              );
                            }}
                            scssProps={{
                              backgroundColor:
                                "var(--ion-color-primary)",
                            }}
                          />
                        }
                      />
                    </div>
                  );
                })}
              </IonAccordion>
            );
          }
        )}
      </IonAccordionGroup>
    </div>
  );
};

export default ImportDataHandler;
